import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "row",
  class: "row mb-10"
}

import { computed } from 'vue';
import { useStore } from 'vuex';

import Select from '@shell/components/form/Select';
import UnitInput from '@shell/components/form/UnitInput';
import { LabeledInput } from '@components/Form/LabeledInput';
import { RcButton } from '@components/RcButton';

import { TYPES } from './shared';
import { useI18n } from '@shell/composables/useI18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceQuotaEntry',
  props: /*@__PURE__*/_mergeModels({
    id: {},
    index: {},
    mode: {},
    types: {}
  }, {
    "resourceType": {},
    "resourceTypeModifiers": {},
    "resourceIdentifier": {},
    "resourceIdentifierModifiers": {},
    "projectLimit": {},
    "projectLimitModifiers": {},
    "namespaceDefaultLimit": {},
    "namespaceDefaultLimitModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['remove'], ["update:resourceType", "update:resourceIdentifier", "update:projectLimit", "update:namespaceDefaultLimit"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const { t } = useI18n(store);

const resourceType = _useModel<string>(__props, 'resourceType');
const resourceIdentifier = _useModel<string>(__props, 'resourceIdentifier');
const projectLimit = _useModel<string>(__props, 'projectLimit');
const namespaceDefaultLimit = _useModel<string>(__props, 'namespaceDefaultLimit');

const typeOption = computed(() => {
  return props.types.find((type) => type.value === resourceType.value) || {};
});

const isCustom = computed(() => {
  return resourceType.value === TYPES.EXTENDED;
});

const removeAriaLabel = computed(() => {
  let identifier;

  if (isCustom.value) {
    identifier = resourceIdentifier.value || t('generic.ariaLabel.genericRow', { index: String(props.index) });
  } else {
    identifier = typeOption.value?.label || t('generic.ariaLabel.genericRow', { index: String(props.index) });
  }

  return t('resourceQuota.ariaLabel.remove', { identifier });
});

const customTypeRules = computed(() => {
  // Return a validation rule that makes the field required when isCustom is true
  if (isCustom.value) {
    return [
      (value: string) => {
        if (!value) {
          return t('resourceQuota.errors.customTypeRequired');
        }

        return undefined;
      }
    ];
  }

  return [];
});

const remove = (id: string) => {
  emit('remove', id);
};

const updateResourceIdentifier = (resourceType: string) => {
  if (resourceType === TYPES.EXTENDED) {
    return;
  }

  resourceIdentifier.value = resourceType;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Select), {
      value: resourceType.value,
      "onUpdate:value": [
        _cache[0] || (_cache[0] = ($event: any) => ((resourceType).value = $event)),
        updateResourceIdentifier
      ],
      class: "mr-10",
      mode: __props.mode,
      options: __props.types,
      "aria-label": _unref(t)('resourceQuota.ariaLabel.resourceType', { row: __props.index }),
      "data-testid": "projectrow-type-input"
    }, null, 8, ["value", "mode", "options", "aria-label"]),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createVNode(_unref(LabeledInput), {
      value: resourceIdentifier.value,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((resourceIdentifier).value = $event)),
      disabled: !isCustom.value,
      required: isCustom.value,
      mode: __props.mode,
      placeholder: _unref(t)('resourceQuota.resourceIdentifier.placeholder'),
      rules: customTypeRules.value,
      "require-dirty": false,
      "aria-label": _unref(t)('resourceQuota.ariaLabel.resourceIdentifier', { row: __props.index }),
      class: "mr-10",
      "data-testid": "projectrow-custom-type-input"
    }, null, 8, ["value", "disabled", "required", "mode", "placeholder", "rules", "aria-label"]),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createVNode(_unref(UnitInput), {
      value: projectLimit.value,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((projectLimit).value = $event)),
      class: "mr-10",
      mode: __props.mode,
      placeholder: typeOption.value.placeholder,
      increment: typeOption.value.increment,
      "input-exponent": typeOption.value.inputExponent,
      "base-unit": typeOption.value.baseUnit,
      "output-modifier": true,
      "aria-label": _unref(t)('resourceQuota.ariaLabel.projectLimit', { row: __props.index }),
      "data-testid": "projectrow-project-quota-input"
    }, null, 8, ["value", "mode", "placeholder", "increment", "input-exponent", "base-unit", "aria-label"]),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createVNode(_unref(UnitInput), {
      value: namespaceDefaultLimit.value,
      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((namespaceDefaultLimit).value = $event)),
      mode: __props.mode,
      placeholder: typeOption.value.placeholder,
      increment: typeOption.value.increment,
      "input-exponent": typeOption.value.inputExponent,
      "base-unit": typeOption.value.baseUnit,
      "output-modifier": true,
      "aria-label": _unref(t)('resourceQuota.ariaLabel.namespaceDefaultLimit', { row: __props.index }),
      "data-testid": "projectrow-namespace-quota-input"
    }, null, 8, ["value", "mode", "placeholder", "increment", "input-exponent", "base-unit", "aria-label"]),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createVNode(_unref(RcButton), {
      variant: "tertiary",
      "aria-label": removeAriaLabel.value,
      onClick: _cache[4] || (_cache[4] = ($event: any) => (remove(__props.id)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('generic.remove')), 1)
      ]),
      _: 1
    }, 8, ["aria-label"])
  ]))
}
}

})